import React from 'react';
import './Flatninedplastic.css';
import weightplas from '../../../imgs/weightplastt.webp';
import weightpla from '../../../imgs/weightplastt1.webp';


const Flatninedplastic = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <div className="Mostcountr">
                    <img src={weightplas} alt="72 Cavity PET Preforms Machine" className="Flatnine" />
                    <img src={weightpla} alt="72 Cavity PET Preforms Machine" className="Flatnine" />
                </div>
                <p className="Generallyin-tex">
                    The nine-legged plastic pallet is forked on all sides, which can be used with manual
                    forklifts and mechanical forklifts, which are simple and convenient to operate.</p>
                <p className="Generallyin-date">Flat nine-legged plastic pallets</p>
                <p className="Generallyin-tex"> are widely used in textile factories, food factories,
                    pharmaceutical factories and other enterprises.</p>
                <p className="Generallyin-date">Grid nine-legged plastic pallets</p>
                <p className="Generallyin-tex">are not suitable for the use of shelves or heavier goods,
                    most of them are used as warehouse goods cushion board anti-slip and also used for
                    the turnover of lighter goods. The nine-legged pallet is a great advantage as empty pallets can
                    nest within each other to take up as little room as possible.</p>
                <p className="Generallyin-date">Three runner pallets</p>
                <p className="Generallyin-tex"> the bottom design of this style is convenient for a variety of forklifts,
                    and steel pipes can be built into the pallet, which is suitable for various shelves in the warehouse.
                    Compared with the grid three-runner pallet, the flat three-runner pallet has a
                    larger bearing capacity and stronger impact resistance. It is used in various industries
                    such as electronic manufacturing, paper industry, chemical industry, logistics industry,
                    warehouse shelf, food, machinery, etc. The grid three runner shaped
                    pallet has good ventilation, lightweight, and relatively inexpensive price.</p>
                <p className="Generallyin-date">Six-runner plastic pallets </p>
                <p className="Generallyin-tex">are mostly used by mechanical forklifts in factory warehouses because
                    manual forklifts are not convenient enter the jack of the pallet and can only be used for
                    mechanical forklifts. Compared with grid field-shaped plastic pallets, flat field-shaped
                    plastic pallets have better stability when carrying goods. In the container, handling and
                    transportation of goods, import and export trade, automobiles, food, tobacco, medicine,
                    paper industry, hotels, printing, electronic appliances, chemical industry, clothing,
                    textile, warehousing, and logistics in
                    grid field shape plastic pallets have a wide range of applications.</p>
            </div>
        </div>
    );
};

export default Flatninedplastic;
